const gitinfo = {
  "commit": "603df05749d635bdbbcbc3ddf2fcbb87a9a1ad5f",
  "abbreviated_commit": "603df057",
  "tree": "e6c578acd717e0c69aada60b001b02bca20c24f7",
  "abbreviated_tree": "e6c578ac",
  "parent": "e86eed4df9304b8fc9f8fdaa29569ae95148733b",
  "abbreviated_parent": "e86eed4d",
  "refs": "HEAD -> main, origin/main, origin/HEAD",
  "encoding": "",
  "subject": "pushed by ylasi@Zeny on Tue 07 Dec 2021 12:06:25 PM CST",
  "sanitized_subject_line": "pushed-by-ylasi-Zeny-on-Tue-07-Dec-2021-12-06-25-PM-CST",
  "body": "",
  "commit_notes": "",
  "verification_flag": "N",
  "signer": "",
  "signer_key": "",
  "author": {
    "name": "Yousef Lasi",
    "email": "raz.baluchi@gmail.com",
    "date": "Tue, 7 Dec 2021 12:06:25 -0600"
  },
  "commiter": {
    "name": "Yousef Lasi",
    "email": "raz.baluchi@gmail.com",
    "date": "Tue, 7 Dec 2021 12:06:25 -0600"
  }
};
export default gitinfo;